import { fontSizes, colors } from '../../../Components/consts'
import { styled } from '@mui/system'

type StyleProps = {
  teamColor: string
}

type PlayerStyleProps = {
  teamColor: string
}

export const PlayerStatStyle = styled('div')<StyleProps>(({ teamColor, theme }) => ({
  color: teamColor,
  fontSize: fontSizes.large,
  fontWeight: 700,
  marginRight: 5,
  [theme.breakpoints.down('md')]: {
    fontSize: fontSizes.semiLarge,
    marginRight: 5,
  },
}))

export const CompareCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minWidth: '95%',
  margin: theme.spacing(1, 1),
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(1, 0),
  },
  '& .heading': {
    textAlign: 'center',
    fontWeight: 700,
    fontSize: fontSizes.semiLarge,
    color: colors.white,
    margin: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.medium,
      margin: theme.spacing(2),
    },
  },
  '& .playersContainer': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'start',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    '& .team': {
      display: 'flex',
      justifyContent: 'center',
      margin: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
        // width: '100%',
        margin: theme.spacing(1, 0),
      },
    },
    '& .divider': {
      width: 3,
      height: '100%',
      margin: theme.spacing(1, 1),
      background: colors.lightGrey,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: 1,
        margin: theme.spacing(1, 0),
      },
    },
  },
}))

export const PlayerItemCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'flex-start',
  '& .playerInfo': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  '& img': {
    height: 50,
    borderRadius: '50%',
    margin: theme.spacing(0, 1),
    [theme.breakpoints.down('sm')]: {
      height: 60,
    },
  },
  '& .right': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '33%',
    margin: theme.spacing(1, 0),
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexWrap: 'wrap-reverse',
      alignItems: 'start',
    },
  },
}))

export const MainPlayerCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(1, 1),
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(1, 0),
  },
  '& .left': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '33%',
    margin: theme.spacing(1, 0),
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexWrap: 'wrap',
    },
  },
  '& .center': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '33%',
    textAlign: 'center',
  },
  '& .right': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: '33%',
    margin: theme.spacing(1, 0),
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexWrap: 'wrap-reverse',
      alignItems: 'start',
    },
  },
}))

export const MatchupPlayerCard = styled('div')(({ theme }) => ({
  width: '215px',
    height: '200px',
    borderRadius: '10px',
    border: 'solid 1px #c7c7c7',
    padding: '0',
    textAlign: 'center',
    '& a': {
      textDecoration: 'none',
    },
}))


export const HeadToHeadOuter = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'flex-start',
  margin: theme.spacing(1),
}))

export const HeadToHeadCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'row',
  margin: theme.spacing(2),
}))

export const WatchMatchupCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(0, 4),
  '& h1': {
    color: colors.white,
    fontWeight: 700,
    fontSize: fontSizes.medium,
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0),
  },
  '& .keyMatchupCon': {
    '& p': {
      color: `${colors.lightestGrey} !important`,
      '& span': {
        color: `${colors.lightestGrey} !important`,
        fontSize: fontSizes.medium,
      },
    },
  },
  '& .keyMatchupText': {
    color: `${colors.lightestGrey} !important`,
    fontSize: fontSizes.medium,
  },
}))

export const PlayerTitleCon = styled('div')(({ theme }) => ({
  display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '10px 10px 0 0',
    height: '50px',
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  '& h3': {
    fontWeight: 'bold',
    fontSize: '1.2rem',
    textAlign: 'center',
    color: colors.white,
  }
}))

export const PositionText = styled('div')(({ theme }) => ({
  fontSize: fontSizes.small,
    color: colors.lightestGrey,
}))

export const PlayerLink = styled('a')(({ theme }) => ({
  textDecoration: 'none',
  margin: 0,
}))



export const PlayerImg = styled('img')(({ theme }) => ({
  height: 50,
  borderRadius: '50%',
  margin: theme.spacing(0, 1),
  [theme.breakpoints.down('sm')]: {
    height: 35,
    margin: theme.spacing(1, 0),
  },
}))

export const KeyPlayerImg = styled('img')(({ theme }) => ({
  height: 50,
  borderRadius: '50%',
  margin: theme.spacing(0, 1),
  [theme.breakpoints.down('sm')]: {
    height: 60,
  },
}))

type InfoConProps = {
  side: 'left' | 'right'
}

export const InfoCon = styled('div')<InfoConProps>(({ side, theme }) => ({
  display: 'block',
  textAlign: side === 'left' ? 'right' : 'left',
  margin: theme.spacing(0, 1),
  '& h2': {
    fontWeight: 700,
    fontSize: fontSizes.semiLarge,
    color: colors.white,
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem',
    },
  },
  '& h3': {
    fontWeight: 700,
    fontSize: fontSizes.medium,
    color: colors.white,
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
  '& p': {
    fontWeight: 500,
    fontSize: fontSizes.medium,
    color: colors.lightGrey,
    marginTop: 5,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.xSmall,
      marginTop: 0,
    },
  },
}))

export const PlayerItemInfo = styled('div')<InfoConProps>(({ side, theme }) => ({
  display: 'block',
  textAlign: side,
  margin: theme.spacing(0, 1),
  '& h2': {
    fontWeight: 700,
    fontSize: fontSizes.medium,
    color: colors.white,
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
  '& p': {
    fontWeight: 500,
    fontSize: fontSizes.small,
    color: colors.lightGrey,
    marginTop: 5,
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
    },
  },
}))

export const StatNameText = styled('div')(({ theme }) => ({
  color: colors.lightGrey,
  fontSize: fontSizes.small,
  fontWeight: 600,
  margin: theme.spacing(0, 2),
  [theme.breakpoints.down('sm')]: {
    fontSize: fontSizes.xSmall,
    margin: theme.spacing(0, 1),
  },
}))

export const StatsTable = styled('div')(({ theme }) => ({
  marginTop: 10,
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  marginBottom: 10,
  '& div': {
    margin: theme.spacing(0, 3),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0, 2),
    },
    '& .statText': {
      fontSize: 15,
      color: colors.white,
      marginTop: 2,
    },
  },
}))

export const Points = styled('div')<PlayerStyleProps>(({ teamColor, theme }) => ({
  color: teamColor,
  fontWeight: 'bold',
  fontSize: 20,
  [theme.breakpoints.down('sm')]: {
    fontSize: 17,
  },
}))
